// extracted by mini-css-extract-plugin
export default {"share-hero":"ShareHero_share-hero__MfZKF","image-grid-container":"ShareHero_image-grid-container__uvdaK","image-grid-column":"ShareHero_image-grid-column__NZ5fA"};